import router from './index.js'

/**
 *
 * 路由守卫
 * 白名单除外
 */
const whiteList = ['/xml', '/requestFromFpx']
const pageList = ['/login', '/paymentOne', '/paymentTwo', '/successful', '/unsuccessful', '/returnToFpx']
const routerName = 'BOCNET'
const permission = router.beforeEach((to, from, next) => {
    //投产的时候开放
    if (to.path === '/xml') {
        next({ path: '/notFound' });
        return;
    }
    if (to.meta.title != undefined && to.meta.title != null) {
        document.title = routerName + "-" + to.meta.title
    } else {
        document.title = routerName
    }

    if (to.path === '/notFound' || to.path === '/error' || to.name === 'TokenError') {
        next()
        return;
    } else {
        // 白名单
        if (whiteList.indexOf(to.path) != -1) {
            next();
            return;
        } else {
            if (pageList.indexOf(to.path) != -1) {
                if (to.path === '/paymentOne' || to.path === '/paymentTwo') {
                    if (window.sessionStorage.getItem('sessionToken')) {
                        next();
                    } else {
                        next({ path: '/tokenError' });
                    }
                }
                next();
            }
        }

        if (pageList.indexOf(to.path) == -1) {
            next({ path: '/notFound' });
        }
    }
})

export default permission;



// WEBPACK FOOTER //
// ./src/router/permission.js